module.exports = __webpack_public_path__ + "img/book-dimensions.0697d448.png";